export default {"src":"/_next/static/media/money_40.0fc95084.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};